<template>
    <div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->

            <h2>Usuários</h2>
            <p>Esta tela é destinada ao gerenciamento dos usuários/alunos deste simulador.</p>
            <span style="font-size: small;">Campos com (*) são de preenchimento obrigatórios.</span>

            <div class="col-md-12 mt-5 mb-5">
                <div class="row text-lg-left">
                    <div class="col-lg-12">
                        <form @submit.prevent="GravarUsuario">
                            <div style="text-align: right; width: 100%;">
                                <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px;" @click="Voltar();">
                                    <u>V</u>oltar
                                </button>
                                <button type="button" class="btn btn-sm btn-light" @click="GravarUsuario();" style="margin-right: 2px; width: 150px;" :disabled="btnSalvar">
                                    <u>S</u>alvar
                                </button>
                            </div>

                            <div class="col-md-8 mb-3">
                                <div class="form-group row"> <!-- Adicione a classe 'row' aqui -->
                                    <div class="col-3"> <!-- Metade da largura disponível -->
                                        <label for="estadooab">OAB:</label>
                                        <select class="form-control" id="estadooab" v-model="dados.selectedEstadoOAB">
                                            <option value="" disabled selected>UF</option>
                                            <option v-for="(estado, sigla) in estados" :key="sigla" :value="sigla">{{ estado.sigla }}</option>
                                        </select>
                                    </div>
                                    <div class="col-9"> <!-- Metade da largura disponível -->
                                        <label>&nbsp;</label> <!-- Espaço reservado para alinhamento vertical do input -->
                                        <input type="text" class="form-control" id="oabNumero" maxlength="6" placeholder="Número da OAB" v-model="dados.oab">
                                    </div>
                                </div>
                            </div>


                            <div class="mb-3">
                                <label for="nome" class="form-label">{{dados.oab.length > 0 ? dados.selectedEstadoOAB : '' }}{{ dados.oab }} Nome*:</label>
                                <input type="text" class="form-control" id="nome" v-model="dados.nome" required>
                            </div>

                            <div class="mb-3">
                                <label for="sexo" class="form-label">Sexo:</label>
                                <select class="form-select" id="sexo" v-model="dados.sexo">
                                <option value="masculino">Masculino</option>
                                <option value="feminino">Feminino</option>
                                <option value="outro">Outro</option>
                                </select>
                            </div>

                            <div class="mb-3">
                                <label for="estadoCivil" class="form-label">Estado Civil:</label>
                                <select class="form-select" id="estadoCivil" v-model="dados.estado_civil">
                                <option value="solteiro">Solteiro(a)</option>
                                <option value="casado">Casado(a)</option>
                                <option value="divorciado">Divorciado(a)</option>
                                <option value="viuvo">Viúvo(a)</option>
                                </select>
                            </div>

                            <div class="mb-3">
                                <label for="dataNascimento" class="form-label">Data de Nascimento:</label>
                                <input type="date" class="form-control" id="dataNascimento" v-model="dados.data_nascimento">
                            </div>

                            <div class="mb-3">
                                <label for="nacionalidade" class="form-label"><img :src="`${BASE_URL}imagens/icons/icone_calendario.jpg`" />Nacionalidade:</label>
                                <select class="form-select" id="nacionalidade" v-model="dados.nacionalidade">
                                <option v-for="pais in paises" :key="pais.sigla" :value="pais.sigla">
                                    {{ pais.gentilico }}
                                </option>
                                </select>
                            </div>

                            <div class="mb-3">
                                <label for="cpf" class="form-label">CPF:</label>
                                <input type="text" class="form-control" id="cpf" v-model="dados.cpf" v-mask="'###.###.###-##'">
                            </div>

                            <div class="mb-3">
                                <label for="identidadeCivil" class="form-label">Identidade Ci<u>v</u>il (RG, CNH, Cert. Nasc.):</label>
                                <input type="text" class="form-control" id="identidade_civil" v-model="dados.identidade_civil">
                            </div>

                            <div class="mb-3">
                                <label for="orgao_expedidor" class="form-label">Órgão Expedidor:</label>
                                <input type="text" class="form-control" id="orgao_expedidor" v-model="dados.orgao_expedidor">
                            </div>

                            <div class="mb-3">
                                <label for="data_emissao" class="form-label">Data de Emissão:</label>
                                <input type="date" class="form-control" id="data_emissao" v-model="dados.data_emissao">
                            </div>

                            <div class="mb-3">
                                <label for="nome_mae" class="form-label">Nome Mãe:</label>
                                <input type="text" class="form-control" id="nome_mae" v-model="dados.nome_mae">
                            </div>

                            <div class="mb-3">
                                <label for="nome_pai" class="form-label">Nome Pai:</label>
                                <input type="text" class="form-control" id="nome_pai" v-model="dados.nome_pai">
                            </div>


                            <div class="mb-3">
                                <label for="endereco" class="form-label">Endereço Logradouro:</label>
                                <input type="text" class="form-control" id="endereco" v-model="dados.endereco">
                            </div>

                            <div class="mb-3">
                                <label for="endereco_numero" class="form-label">Número:</label>
                                <input type="text" class="form-control" id="endereco_numero" v-model="dados.numero">
                            </div>

                            <div class="mb-3">
                                <label for="bairro" class="form-label">Bairro:</label>
                                <input type="text" class="form-control" id="bairro" v-model="dados.bairro">
                            </div>

                            <div class="mb-3">
                                <label for="pais" class="form-label">P<u>a</u>ís:</label>
                                <select class="form-select" id="pais" v-model="dados.pais">
                                <option v-for="pais in paises" :key="pais.sigla" :value="pais.sigla">
                                    {{ pais.nome_pais }}
                                </option>
                                </select>
                            </div>

                            <div class="mb-3">
                                <label for="uf" class="form-label"><u>U</u>F:</label>
                                <select class="form-control" id="estado" v-model="dados.uf">
                                    <option v-for="(estado, sigla) in estados" :key="sigla" :value="sigla">{{ estado.sigla }}</option>
                                </select>
                            </div>

                            <div class="mb-3">
                                <label for="Localidade" class="form-label">Locali<u>d</u>ade:</label>
                                <input type="text" class="form-control" id="localidade" v-model="dados.localidade">
                            </div>

                            <div class="mb-3">
                                <label for="Telefone" class="form-label"><u>T</u>elefone:</label>
                                <input type="text" class="form-control" id="telefone" v-model="dados.telefone">
                            </div>

                            <div class="mb-3">
                                <label for="email" class="form-label">E-M<u>a</u>il*:</label>
                                <input type="text" class="form-control" id="email" v-model="dados.email" required>
                            </div>

                            <div class="mb-3">
                                <label for="receber_info" class="form-label"><u>R</u>eceber informações de prazos por email:&nbsp;&nbsp;</label>
                                <label>
                                    <input type="radio" v-model="dados.receber_informacao_prazos_email" value="1" selected>&nbsp;Sim&nbsp;
                                </label>
                                <label>
                                    <input type="radio" v-model="dados.receber_informacao_prazos_email" value="0">&nbsp;Não&nbsp;
                                </label>
                            </div>

                            <div class="mb-3">
                                <label for="receber_esquecimento" class="form-label"><u>U</u>sar email para esquecimento de senha? :&nbsp;&nbsp;</label>
                                <label>
                                    <input type="radio" v-model="dados.usar_email_esquecimento_senha" value="1" selected>&nbsp;Sim&nbsp;
                                </label>
                                <label>
                                    <input type="radio" v-model="dados.usar_email_esquecimento_senha" value="0">&nbsp;Não&nbsp;
                                </label>
                            </div>

                            <div class="mb-3">
                                <label for="receber_distribuicap" class="form-label"><u>R</u>eceber informações da distribuição por email?:&nbsp;&nbsp;</label>
                                <label>
                                    <input type="radio" v-model="dados.receber_informacao_distribuicao_email" value="1" selected>&nbsp;Sim&nbsp;
                                </label>
                                <label>
                                    <input type="radio" v-model="dados.receber_informacao_distribuicao_email" value="0">&nbsp;Não&nbsp;
                                </label>
                            </div>

                            <div class="mb-3">
                                <p class="font-weight-bold" style="font-size: small; background-color: lightgray;">
                                    <label style="color: red;"><strong>Atenção</strong></label><br />
                                Senhores Advogados:<br />O email não dispensa a consulta eletrônica para fins de intimação e citação (art. 5º da Lei nº 11.419/2006).
                                </p>
                            </div>

                            <br />

                            <div class="mb-3">
                                <p class="font-weight-bold" style="font-size: small; background-color: lightgray;">
                                    <label style="color: red;"><strong>Atenção 2</strong></label><br />
                                As informações até aqui inseridas são idênticas ao sistema do eproc oficial. Os próximos campos são de uso exclusivo deste simulador.
                                </p>
                            </div>

                            <div class="mb-3">
                                <label for="registro_academico" class="form-label"><u>R</u>A (Registro Acadêmico):</label>
                                <input type="text" class="form-control" id="registro_academico" v-model="dados.registro_academico">
                            </div>

                            <div class="mb-3">
                                <label for="senha" class="form-label"><u>S</u>enha de acesso ao simulador*: {{ (this.tela_editar ? "(Preencha apenas se deseja alterar a senha)" : "") }}</label>
                                <input type="password" class="form-control" id="senha" v-model="dados.senha" required>
                            </div>

                            <div class="mb-3">
                                <label for="senha_confirmar" class="form-label">Confirme a senha*:</label>
                                <input type="password" class="form-control" id="senha_confirmar" v-model="dados.senha_confirmar" required>
                            </div>

                            <div class="mb-3">
                                <label for="turmas" class="form-label">Turma(s):</label>
                                <input type="text" v-model="busca_turma" @input="buscarTurmas" @focus="buscarTurmas" class="form-control" placeholder="Digite para buscar turmas" />
                                <div v-if="turmasFiltradas.length" class="dropdown-menu show">
                                    <a v-for="turma in turmasFiltradas" :key="turma.id" class="dropdown-item" href="#" @click.prevent="selecionarTurma(turma)">
                                        {{ turma.descricao }}
                                    </a>
                                </div>
                                <div v-if="turmasSelecionadas.length" class="mt-2">
                                    <span v-for="turma in turmasSelecionadas" :key="turma.id" class="badge bg-secondary m-1">
                                        {{ turma.descricao }}
                                        <button type="button" class="btn-close" @click="removerTurma(turma)"></button>
                                    </span>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label for="administrador" class="form-label">Criar este usuário ativo no simulador?&nbsp;&nbsp;</label><br />
                                <label>
                                    <input type="radio" v-model="dados.ativo" value="1" selected @change="verificarCadastroAtivo">&nbsp;Sim&nbsp;
                                </label>
                                <label>
                                    <input type="radio" v-model="dados.ativo" value="0" @change="verificarCadastroAtivo">&nbsp;Não&nbsp;
                                </label>
                                <br />
                                <span v-if="exibirMsgAtivo" style="color: red; font-size: small;">Ao cadastro o aluno como inativo, ele ficará com o status de pendente no simulador e só conseguirá acessar o mesmo após sua aprovação em menu principal -> "Administrador", submenu -> "Alunos Pendentes".</span>
                            </div>

                            <div class="mb-3">
                                <label for="administrador" class="form-label">Este usuário é professor ou administrador do sistema?&nbsp;&nbsp;</label><br />
                                <label>
                                    <input type="radio" v-model="dados.is_admin" value="1">&nbsp;Sim&nbsp;
                                </label>
                                <label>
                                    <input type="radio" v-model="dados.is_admin" value="0" selected>&nbsp;Não&nbsp;
                                </label>
                            </div>

                            <div class="mb-3">
                                <label for="comunicacoes_twm" class="form-label">Este usuário pode receber comunicações da TWM Simuladores e seus parceiros, como podcast, palestras e eventos relacionados a área do Direito.&nbsp;&nbsp;</label><br />
                                <label>
                                    <input type="radio" v-model="dados.aceita_receber_comunicacoes" value="1" selected>&nbsp;Sim&nbsp;
                                </label>
                                <label>
                                    <input type="radio" v-model="dados.aceita_receber_comunicacoes" value="0">&nbsp;Não&nbsp;
                                </label>
                            </div>

                            <div class="mb-3">
                                
                                <label for="receber_distribuicap" class="form-label">Este usuário está de acordo de conceder meus dados para uso exclusivo deste simulador.&nbsp;&nbsp;</label><br />
                                <label>
                                    <input type="radio" v-model="dados.aceita_uso_dados_simulador" value="1" selected @change="verificarAceiteTermos">&nbsp;Sim&nbsp;
                                </label>
                                <label>
                                    <input type="radio" v-model="dados.aceita_uso_dados_simulador" value="0" @change="verificarAceiteTermos">&nbsp;Não&nbsp;
                                </label>
                                <br />
                                <span v-if="exibirAceite" style="color: red; font-size: small;">É necessário estar de acordo para efetivar o cadastro.</span>
                            </div>

                            <div style="text-align: right; width: 100%;" class="mb-5">
                                <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px;" @click="Voltar();">
                                    <u>V</u>oltar
                                </button>
                                <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 150px;" :disabled="btnSalvar" @click="GravarUsuario">
                                    <u>S</u>alvar
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>


    </div>
  </template>
  
<script>
  import axios from 'axios';
  export default {
    data() {
        return {
            BASE_URL: window.Laravel.baseUrl,
            estados: {},
            paises: [],

            dados: {
                    nome:'',
                    selectedEstadoOAB: '',
                    oab: '',
                    cpf: '',
                    sexo: '',
                    estado_civil: '',
                    data_nascimento: '',
                    nacionalidade: 'BR', // Defina o valor inicial brasileiro como padrão
                    identidade_civil: '',
                    orgao_expedidor: '',
                    data_emissao: '',
                    nome_mae: '',
                    nome_pai: '',
                    endereco: '',
                    numero: '',
                    complemento: '',
                    bairro: '',
                    cep: '',
                    pais: '',
                    uf: '',
                    localidade: '',
                    telefone: '',
                    email: '',
                    selectedEstado: '',

                    receber_informacao_prazos_email: '1',
                    usar_email_esquecimento_senha: '1',
                    receber_informacao_distribuicao_email: '1',

                    registro_academico: '',
                    is_admin: '0',
                    ativo: '1',

                    aceita_receber_comunicacoes: '1',
                    aceita_uso_dados_simulador: '1',
                    senha: '',
                    senha_confirmar: '',
                    turmas_ids: [],

                    cadastro_tela_admin: 1,
            },
            btnSalvar: false,
            exibirAceite: false,
            exibirMsgAtivo: false,

            busca_turma: '',
            turmas: [], // Todas as turmas disponíveis
            turmasFiltradas: [], // Turmas filtradas com base na busca
            turmasSelecionadas: [] // Turmas selecionadas pelo usuário
        };
        
    },
    props: {
        tela_editar: Number,
        usuario_editar: Object,
        user: Object
    },
    mounted() {
        this.carregarEstados();
        this.dados.selectedEstadoOAB = "RS";
        this.CarregarPaises();
        this.VerificaCarregamento();

    },
    methods: {

        
        VerificaCarregamento(){
            if (this.tela_editar === 1 && Object.keys(this.usuario_editar).length === 0){
                /* Esse if verifica se é tela de edição. Se for, o usuário não pode ser vazio, pois se for vazio quer dizer que o usuário está mexendo no id do link. Então redireciona. */
                window.location.href = this.BASE_URL + 'consulta_aluno';
            }
            else if(this.tela_editar === 1){
                this.CarregarUsuario();
            }
        },
        CarregarUsuario(){
            this.dados.id = this.usuario_editar.id; //Cria a informação id. Se contem id em dados é porque é edição de cadastro.
            this.dados.nome = this.usuario_editar.name;

            if(this.usuario_editar.oab){
                const oabInfo = this.separarOab(this.usuario_editar.oab);
                this.dados.selectedEstadoOAB = oabInfo.uf;
                this.dados.oab = oabInfo.numero;
            }

            this.dados.cpf = this.usuario_editar.cpf;
            this.dados.sexo = this.usuario_editar.sexo;
            this.dados.estado_civil = this.usuario_editar.estado_civil;
            this.dados.nacionalidade = this.usuario_editar.nacionalidade;
            this.dados.identidade_civil = this.usuario_editar.identidade_civil;
            this.dados.data_nascimento = this.usuario_editar.data_nascimento;
            this.dados.orgao_expedidor = this.usuario_editar.orgao_expedidor;
            this.dados.data_emissao = this.usuario_editar.data_emissao;
            this.dados.nome_mae = this.usuario_editar.nome_mae;
            this.dados.nome_pai = this.usuario_editar.nome_pai;
            this.dados.endereco = this.usuario_editar.endereco;
            this.dados.numero = this.usuario_editar.numero;
            this.dados.complemento = this.usuario_editar.complemento;
            this.dados.bairro = this.usuario_editar.bairro;
            this.dados.cep = this.usuario_editar.cep;
            this.dados.pais = this.usuario_editar.pais;
            this.dados.uf = this.usuario_editar.uf;
            this.dados.localidade = this.usuario_editar.localidade;
            this.dados.telefone = this.usuario_editar.telefone;
            this.dados.email = this.usuario_editar.email;
            this.dados.selectedEstado = this.usuario_editar.selectedEstado;
            this.dados.receber_informacao_prazos_email = this.usuario_editar.receber_informacao_prazos_email;
            this.dados.usar_email_esquecimento_senha = this.usuario_editar.usar_email_esquecimento_senha ? "1" : "0";
            this.dados.receber_informacao_distribuicao_email = this.usuario_editar.receber_informacao_distribuicao_email ? "1" : "0";
            this.dados.registro_academico = this.usuario_editar.registro_academico;

            if(this.usuario_editar.ativo === false)
                this.dados.ativo = '0';
            else this.dados.ativo = '1';
            this.verificarCadastroAtivo(); //Chama essa função para aparecer a mensagem de ativo se necessário.

            if(this.usuario_editar.is_admin === false)
                this.dados.is_admin = '0';
            else this.dados.is_admin = '1';

            this.dados.aceita_receber_comunicacoes = this.usuario_editar.aceita_receber_comunicacoes ? "1" : "0";
            this.dados.aceita_uso_dados_simulador = this.usuario_editar.aceita_uso_dados_simulador ? "1" : "0";

            this.buscarTurmasUsuario(this.usuario_editar.id);


        },
        buscarTurmasUsuario(userId) {
            axios.get(this.BASE_URL + 'turmas/buscar_turmausuario', {
                params: {
                    userId: userId
                }
            })
            .then(response => {
                this.turmasSelecionadas = response.data;
            })
            .catch(error => {
                console.error('Erro na busca das turmas deste usuário:', error);
            });
        },

        separarOab(oab) {
            let uf = '';
            let numero = '';

            // Verifica se a string tem 8 caracteres (ou seja, inclui a UF)
            if (oab.length === 8) {
                uf = oab.substring(0, 2);
                numero = oab.substring(2);
            } else {
                // Se a string tiver apenas 6 caracteres, ela não tem UF
                numero = oab;
            }
            return { uf, numero };
        },
        Voltar(){
            window.location.href = this.BASE_URL + 'consulta_aluno';
        },
        carregarEstados() {
            fetch(this.BASE_URL + 'common/cidades.json')
                .then(response => response.json())
                .then(data => {
                this.estados = data;
                })
                .catch(error => {
                console.error('Erro ao carregar estados:', error);
                });
        },

        CarregarPaises(){
            fetch(this.BASE_URL + 'common/nacionalidades.json')
                .then(response => response.json())
                .then(data => {
                    this.paises = data;
                })
                .catch(error => console.error('Erro ao carregar países:', error));
            
        },

        buscarTurmas() {
            axios.get(this.BASE_URL + 'turmas/buscar', {
                params: {
                    query: this.busca_turma
                }
            })
            .then(response => {
                this.turmasFiltradas = response.data.filter(turma => 
                    !this.turmasSelecionadas.some(selecionada => selecionada.id === turma.id)
                );
            })
            .catch(error => {
                console.error('Erro na busca das turmas:', error);
            });
        },
        selecionarTurma(turma) {
            if (!this.turmasSelecionadas.includes(turma)) {
                this.turmasSelecionadas.push(turma);
            }
            this.busca_turma = '';
            this.turmasFiltradas = [];
        },
        removerTurma(turma) {
            this.turmasSelecionadas = this.turmasSelecionadas.filter(t => t !== turma);
        },

        verificarAceiteTermos(){
            this.btnSalvar = this.dados.aceita_uso_dados_simulador === '0';
            this.exibirAceite = this.dados.aceita_uso_dados_simulador === '0';
        },
        verificarCadastroAtivo(){
            this.exibirMsgAtivo = this.dados.ativo === '0';
        },
        Validacoes(){
            if(this.dados.nome === ''){
                alert('Campo nome não pode ser vazio.');
                return false;
            }

            if(this.dados.email === ''){
                alert('Campo email não pode ser vazio.');
                return false;
            }


            /* if(this.dados.data_nascimento === ''){
                alert('Campo data de nascimento não pode ser vazio.');
                return false;
            } */

            if(!this.tela_editar){
                if(this.dados.senha === ''){
                    alert('Campo senha não pode ser vazio.');
                    return false;
                }

                if(this.dados.senha.length < 6){
                    alert('A senha deve conter no mínimo 6 caracteres.');
                    return false;
                }
            }

            if(this.dados.senha != this.dados.senha_confirmar){
                alert('Os campos de senha precisam ser iguais.');
                return false;
            }

            return true;
        },

        GravarUsuario(){
            /* Validações */
            if(!this.Validacoes()){
                //Se não passar pelas validacoes, para a função
                return;
            }

            this.dados.turmas_ids = this.turmasSelecionadas.map(turma => turma.id);
            this.dados.tela_editar = this.tela_editar; //Se essa variavel é enviada, faz edição lá no código.
            
            axios.post(this.BASE_URL + 'advogado_cadastrar', this.dados)
                    .then(response => {
                        alert(response.data.message);
                        // Adicione lógica adicional após a autenticação bem-sucedida
                        window.location.href = this.BASE_URL + 'consulta_aluno';

                    })
                    .catch(error => {
                        console.log('Caiu no catch: ' + error.message);

                        // Se houver erros de validação, exiba as mensagens para o usuário
                        if (error.response && error.response.status === 422) {
                            const validationErrors = error.response.data.errors;

                            // Exiba as mensagens de erro para o usuário
                            for (const field in validationErrors) {
                                console.error(`Erro no campo ${field}: ${validationErrors[field][0]}`);

                                if(field == 'email')
                                {
                                    alert("Cadastro não efetivado. E-mail já cadastro.");
                                    return;
                                }
                            }
                        } else if (error.response && error.response.status === 409) {
                            // Caso específico: E-mail já cadastrado
                            alert('O e-mail já está cadastrado.');
                        } else {
                            // Outros casos de erro, exibir uma mensagem genérica ou tomar ação apropriada
                            console.error('Erro inesperado:', error.message);
                        }
                    });


        },

    },

    
};
</script>

<style scoped>
.btn-primary {
    background-color: #007ebd;
}

/* Cor do botão no hover (escurecido) */
.btn-primary:hover {
    background-color: #005e94; /* Ajuste o valor percentual conforme necessário */
}

.btn-light{
    color: rgb(62, 136, 227); 
    border: solid 1px lightgray;
}

button u {
  text-decoration: underline;
}
</style>
